import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar, Clock, User, GraduationCap, Phone } from 'lucide-react';

const DemoBookingCard = ({ booking, onAccept, onReject, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      case 'confirmed':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'completed':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      case 'cancelled':
        return 'bg-red-100 text-red-800 border-red-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardHeader className="pb-3">
        <div className="flex justify-between items-start">
          <CardTitle className="text-lg flex items-center gap-2">
            <User className="w-5 h-5" />
            {booking.student.name}
          </CardTitle>
          <Badge className={getStatusColor(booking.status)}>
            {booking.status.toUpperCase()}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div className="flex items-center gap-2">
            <GraduationCap className="w-4 h-4 text-gray-500" />
            <span>Class {booking.student.class} - {booking.student.board}</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4 text-gray-500" />
            <span>{new Date(booking.demo_date).toLocaleDateString()}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-gray-500" />
            <span>{booking.demo_time}</span>
          </div>
        </div>

        <div className="border-t pt-3 space-y-1">
          <p className="text-sm font-medium">Customer: {booking.customer.name}</p>
          <div className="flex items-center gap-2 text-xs text-gray-600">
            <Phone className="w-3 h-3" />
            <span>{booking.customer.phone}</span>
          </div>
        </div>

        {booking.notes && (
          <div className="border-t pt-3">
            <p className="text-xs text-gray-600">
              <span className="font-medium">Notes:</span> {booking.notes}
            </p>
          </div>
        )}

        <div className="flex gap-2 pt-2">
          {booking.status === 'pending' && (
            <>
              <Button
                onClick={() => onAccept(booking.id)}
                className="flex-1 bg-green-600 hover:bg-green-700"
                size="sm"
              >
                Accept
              </Button>
              <Button
                onClick={() => onReject(booking.id)}
                variant="outline"
                className="flex-1 border-red-300 text-red-600 hover:bg-red-50"
                size="sm"
              >
                Reject
              </Button>
            </>
          )}
          <Button
            onClick={() => onViewDetails(booking)}
            variant="outline"
            className="flex-1"
            size="sm"
          >
            View Details
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DemoBookingCard;
